import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch (e) {
        try {
          await api.post("/auth/refresh");
          const r2 = await api.get("/auth/me");
          setUser(r2.data);
        } catch (e2) {
          setUser(false);
        }
      } finally {
        setReady(true);
      }
    })();
  }, []);

  useEffect(() => {
    const onUnauth = () => setUser(false);
    window.addEventListener("pc-unauthorized", onUnauth);
    return () => window.removeEventListener("pc-unauthorized", onUnauth);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, apiErr }}>
      {children}
    </AuthCtx.Provider>
  );
}
